"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";

function GlossaryPageHeader(): ReactElement {
  const t = useTranslations("glossary.PageHeader");
  return (
    <header className="min-h-32 py-4 flex flex-row items-end border-b bg-accent overflow-hidden">
      <div className="max-w-7xl mx-auto flex-1 flex flex-row justify-between px-4 animate__animated animate__slideInUp animate__faster">
        <h1 className="text-2xl md:text-3xl font-semibold">{t("title")}</h1>
      </div>
    </header>
  );
}

export { GlossaryPageHeader };
